




















































































































import menuButton from "@/components/menuButton.vue";
import GlossaryPopUp from "@/components/GlossaryPopUp.vue";
import ReferencesPopUp from "@/components/ReferencesPopUp.vue";
import AbbrevsPopUp from "@/components/AbbrevsPopUp.vue";
export default {
  name: "drug2_menu",
  components: {
    menuButton,
    GlossaryPopUp,
    ReferencesPopUp,
    AbbrevsPopUp
  },
  mounted() {
    this.$on('click-refs', function() {
      this.$refs.refpop.showRefs();
    })
    this.$on('click-gloss', function() {
      this.$refs.glosspop.showGloss();
    })
    this.$on('click-abbrevs', function() {
      this.$refs.abbrevpop.showAbbrevs();
    })
  }
};
